const notification = document.getElementById("success_notification");
const closeNotificationButton = document.getElementById("close_success_notification");
if(closeNotificationButton)
{
    // Event listener for the "Close" button
    closeNotificationButton.addEventListener("click", (event) =>  notification.classList.add("hidden"));

}

// Function to hide the notification
function hideNotification() {
    notification.classList.add("hidden");
}


export function issueFinished() {
    notification.classList.remove("hidden");
}
